import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18.5 21.5H5.5M19.5 9.5H14C13.1716 9.5 12.5 8.82843 12.5 8V2.5M19.5 9.5V9.12132C19.5 8.7235 19.342 8.34196 19.0607 8.06066L13.9393 2.93934C13.658 2.65804 13.2765 2.5 12.8787 2.5H12.5M19.5 9.5V10.5M12.5 2.5H7.5C5.84315 2.5 4.5 3.84315 4.5 5.5V10.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M5.76975 12.4C6.56975 12.4 7.19308 12.5933 7.63975 12.98C8.09308 13.36 8.31975 13.9 8.31975 14.6C8.31975 15.3 8.09308 15.8433 7.63975 16.23C7.19308 16.61 6.56975 16.8 5.76975 16.8H4.45975V19H2.73975V12.4H5.76975ZM5.49975 15.51C6.22641 15.51 6.58975 15.2067 6.58975 14.6C6.58975 13.9933 6.22641 13.69 5.49975 13.69H4.45975V15.51H5.49975Z"
            fill="currentColor"
        />
        <path
            d="M12.2194 12.4C13.2528 12.4 14.0428 12.6867 14.5894 13.26C15.1428 13.8333 15.4194 14.6467 15.4194 15.7C15.4194 16.7533 15.1428 17.5667 14.5894 18.14C14.0428 18.7133 13.2528 19 12.2194 19H9.41943V12.4H12.2194ZM12.0494 17.7C12.6094 17.7 13.0161 17.5333 13.2694 17.2C13.5294 16.86 13.6594 16.36 13.6594 15.7C13.6594 15.04 13.5294 14.5433 13.2694 14.21C13.0161 13.87 12.6094 13.7 12.0494 13.7H11.1394V17.7H12.0494Z"
            fill="currentColor"
        />
        <path
            d="M21.7272 13.73H18.3172V15.13H21.0372V16.46H18.3172V19H16.5972V12.4H21.7272V13.73Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
